import { render, staticRenderFns } from "./CommunityMessageInputBar.vue?vue&type=template&id=0cd6de8a&scoped=true&"
import script from "./CommunityMessageInputBar.vue?vue&type=script&lang=js&"
export * from "./CommunityMessageInputBar.vue?vue&type=script&lang=js&"
import style0 from "./CommunityMessageInputBar.vue?vue&type=style&index=0&id=0cd6de8a&scoped=true&lang=css&"
import style1 from "./CommunityMessageInputBar.vue?vue&type=style&index=1&id=0cd6de8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6de8a",
  null
  
)

export default component.exports